export default "__VITE_ASSET__V3ODnO0p__"